<template>
  <div class="bookmark-list-container">
    <ul v-if="bookmarks && bookmarks.length > 0">
      <li v-for="bookmark in bookmarks" :key="bookmark.bookmark_id || bookmark.url">
        <b><a :href="bookmark.url" target="_blank" rel="noopener noreferrer">
          {{ bookmark.title || 'Untitled' }}
          </a>
        </b>
        <br/><br/>
        {{ bookmark.recommendation }}
        <br/>
        <br/>
        <a :href="'https://instapaper.com/read/' + bookmark.id" target="_blank" rel="noopener noreferrer">

          Instapaper
        </a>
      </li>
    </ul>
    <p v-else>No unread articles found.</p>
  </div>
</template>

<script>
export default {
  name: 'BookmarkList',
  props: {
    bookmarks: {
      type: Array,
      required: true,
      default: () => [] // Default to empty array
    }
  }
};
</script>

<style scoped>
.bookmark-list-container {
  text-align: left;
  max-width: 600px; /* Adjust as needed */
  margin: 20px auto;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

li a {
  text-decoration: none;
  color: #333;
}

li a:hover {
  color: #42b983; /* Vue green */
}
</style>
